import styled from 'styled-components'

import { Tooltip } from '@/components/ui/tooltip'

export const TruncatedLabel = styled.span`
  display: block;
  min-width: 0;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

// Note: lets the label shrink and truncate inside its flex row
export const LabelTooltip = styled(Tooltip)(() => ({
  minWidth: 0,
}))
